















import { Component, Vue } from 'vue-property-decorator';
@Component
export default class HeaderView extends Vue {
  async scroll() {
    console.log('scroll');
    
      document.getElementById('Services').scrollIntoView({
        behavior: "smooth"
      });
  }
  // setBackground () {
  //   let img = new Image();

  //   img.onload = () => {
  //     console.log('img loaded');
  //     this.backgroundImage = 'https://static.ty-sb1.tayeh.ir/tayeh-panel/assets/images/landing_bg.png';
  //     // Here you can reveal the image
  //   }

  //   img.src = 'https://static.ty-sb1.tayeh.ir/tayeh-panel/assets/images/landing_bg.png';
  //   this.backgroundImage = ''
  // }
  // mounted () {
  //   this.setBackground()
  // }
}
